module.exports = __webpack_public_path__ + "static/media/LikeSmall.91741e91.svg";